export default "__VITE_ASSET__CnTzvIJz__"